import React, { useState } from "react";
import { Grid, Typography, Box, Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { sendUserToQlik } from "../../app/userSlice";
import { SnackDisplay } from "@lp/lp-ui";

export default function UserQlikPanel() {
  const dispatch = useAppDispatch();
  const userState = useAppSelector((store) => store.user);
  const [snackMessage, setSnackMessage] = useState("");

  async function handleSendUserToQlik(): Promise<void> {
    dispatch(sendUserToQlik(userState.id));
  }

  return (
    <React.Fragment>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography variant="h5" color="primary">
            Qlik
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            Click the button below to send this user to Qlik. This will create
            the user in Qlik if they do not already exist.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Box pt={2}>
            <Button
              onClick={handleSendUserToQlik}
              variant="contained"
              color="primary"
              disabled={!userState?.data?.enabled}
            >
              Send User to Qlik
            </Button>
          </Box>
        </Grid>
      </Grid>
      {snackMessage && (
        <SnackDisplay
          snack={snackMessage}
          handleClose={() => setSnackMessage("")}
        />
      )}
    </React.Fragment>
  );
}
